<template>
  <div class="book-cards" style="cursor: pointer">
    <slot name="columnBook" class="box-slot"></slot>
    <div class="box-content">
      <p>{{ props.img_txt }}</p>
      <!-- <p>
        甄选6套代表性真题，模拟真实考场成套演练甄选6套代表性真题，模拟真实考场成套演练
      </p> -->
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  img_txt: {
    type: String,
    default: "",
  },
});
</script>

<style scoped lang="scss">
.book-cards {
  width: 252px;
  .box-content {
    width: 100%;
    > p:nth-of-type(1) {
      font-size: 16px;
      font-weight: 400;
      color: #000;
      margin-bottom: 5px;
      line-height: 25px;
    }
    // > p:nth-of-type(2) {
    //   font-size: 14px;
    //   font-weight: 400px;
    //   color: #000;
    // }
  }
}
</style>
